import { Icon, Tag, Text } from 'ui';

const OrganizationStatus = () => (
  <Tag color="success" icon={<Icon icon="check-circle-fill" />} noBackground size="medium">
    <Text>Joined</Text>
  </Tag>
);

export default OrganizationStatus;
